<template>
    <div class="sub-header">
        <el-row :gutter="2">
            <el-col :span="12"><h3>{{ companyinfo.companyname }} - 报价记录</h3></el-col>
            <el-col :span="12" align="right">
                <el-button type="primary" size="small" @click="showQuoteDialog" icon="Plus">
                    新增报价
                </el-button>
            </el-col>
        </el-row>
    </div>

    <el-table ref="quotationTable"
              :data="documents"
              highlight-current-row
              @current-change="handleQuotationSelect"
              @sort-change="sortChange"
              style="width: 100%"
              class="quotation-table">
        <el-table-column prop="docnumber" label="单号" width="160" sortable>
            <template #default="{row}">
                {{docnocal(row.documentid,row.docnumber)}}
            </template>
        </el-table-column>
        <el-table-column prop="incoterms" label="条款" width="80" sortable />
        <el-table-column prop="currency" label="币种" width="80" sortable />
        <el-table-column prop="totalamount" label="总金额" width="140">
            <template #default="{row}">
                ${{ (row.totalamount || 0).toFixed(2) }}
            </template>
        </el-table-column>
        <el-table-column prop="" label="操作">
            <template #default="{row}">
                <el-button size="small" type="primary" @click="checkquotation(row)">报价单</el-button>
                <el-button size="small" type="danger" @click="deletequotation(row.documentid)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog v-model="QuoteDialog"
               :title="dialogTitle"
               width="80%"
               destroy-on-close>
        <el-form :model="CurrentQuote" label-width="100px">
            <el-row :gutter="8">
                <el-col :span="12">
                    <el-form-item label="客户单位">
                        <el-input type="text" :value="companyinfo.companyname" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人" required>
                        <el-select v-model="CurrentQuote.buyerNo">
                            <el-option v-for="item in companyinfo.contacts" :key="item.contactid" :value="item.contactid" :label="item.fullname" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="1">
                <el-col :span="6">
                    <el-form-item label="报价术语" required>
                        <el-select v-model="CurrentQuote.Incoterm" style="width:100px"><el-option v-for="term in IncotermOptions" :key="term" :value="term" :label="term" /></el-select>
                        <el-input v-model="CurrentQuote.destination" style="width:100px;margin-left:10px" />

                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="付款方式" required>
                        <el-input v-model="CurrentQuote.payment" />
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="4">
                <el-col :span="6"><el-form-item label="报价有效期" required><el-input-number v-model="CurrentQuote.validate" :min="7" :step="5" />  天</el-form-item></el-col>
                <el-col :span="6">
                    <el-form-item label="币种" required>
                        <el-select v-model="CurrentQuote.Currency">
                            <el-option value="USD" label="USD" />
                            <el-option value="RMB" label="RMB" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6"><el-form-item label="合计金额"><el-input type="text" :value="'$' + quoteAmount.toFixed(2)" disabled /></el-form-item></el-col>
                <el-col :span="6"><el-form-item label="货期">取所有产品货期的最大值</el-form-item></el-col>
            </el-row>


        </el-form>

        <div style="margin-bottom: 15px;">
            <el-button type="primary" @click="showAddProductDialog" icon="Plus">添加产品</el-button>
            <el-select v-if="companies.length" v-model="CurrentQuote.profileid" style="width:220px" placeholder="抬头公司">
                <el-option v-for="option in companies" :key="option.id" :value="option.id"
                           :label="option.profilename || option.companyname" />
            </el-select>
        </div>

        <el-table ref="QuoteProductTable"
                  :data="CurrentQuote.products"
                  highlight-current-row
                  @current-change="handleQuoteSelect"
                  style="width: 100%"
                  border>
            <el-table-column prop="productmodel" label="型 号 (Model)" width="120" />
            <el-table-column prop="proddescription" label="产品描述(Description)" />
            <el-table-column prop="leadtime" label="货 期(days)" width="120" align="center">
                <template #default="{row}">
                    <el-input-number v-model="row.leadtime" :min="7" style="width: 80px;" size="small" @change="updateTotals" />
                </template>
            </el-table-column>
            <el-table-column prop="qty" label="数 量(kit)" width="120" align="center">
                <template #default="{row}">
                    <el-input-number v-model="row.qty" :min="1" style="width: 80px;" size="small" @change="updateTotals" />
                </template>
            </el-table-column>
            <el-table-column prop="price" label="单 价($)" width="120" align="center">
                <template #default="{row}">
                    <el-input v-model="row.price" @change="updateTotals" style="width: 80px;" size="small" />
                </template>
            </el-table-column>
            <el-table-column label="小 计(US$)" width="120" align="right">
                <template #default="{row}">
                    ${{ (row.price * row.qty).toFixed(2) }}
                </template>
            </el-table-column>
            <el-table-column label="质保期" property="warranty" width="120" align="right" />
            <el-table-column prop="notes" label="备 注(Notes)" width="200" />
            <el-table-column label="操作" width="120" align="center" fixed="right">
                <template #default="{row, $index}">
                    <el-button size="small" type="danger" @click="removeProduct($index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="margin-top: 20px; text-align: right;">
            <el-button @click="QuoteDialog = false">取消</el-button>
            <el-button type="primary" @click="submitQuote">提交报价</el-button>
        </div>
    </el-dialog>

    <!-- 添加/编辑产品对话框 -->
    <el-dialog v-model="productDialogVisible"
               :title="productDialogTitle"
               width="50%">
        <el-form :model="currentProduct" label-width="120px">
            <el-row :gutter="8">
                <el-col :span="24">
                    <el-form-item label="选择产品" required>
                        <el-select v-model="currentProduct.productmodel"
                                   filterable
                                   remote
                                   :remote-method="fetchProductOptions"
                                   :loading="productLoading"
                                   @change="handleProductSelect"
                                   placeholder="请输入产品关键词搜索"
                                   style="width: 100%">
                            <el-option v-for="item in productOptions"
                                       :key="item.value"
                                       :label="item.productcode"
                                       :value="item.productid"
                                       @select="handleProductSelect">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="产品描述">
                <el-input v-model="currentProduct.proddescription" type="textarea" :rows="3" />
            </el-form-item>
            <el-row :gutter="8">
                <el-col :span="12">
                    <el-form-item label="单价(US$)" required>
                        <el-input-number v-model="currentProduct.price" :min="0" :precision="2" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="数量(套)" required>
                        <el-input-number v-model="currentProduct.qty" :min="1" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="12">
                    <el-form-item label="质保期(月)" required>
                        <el-input-number v-model="currentProduct.warranty" :min="6" step="6" />
                    </el-form-item>
                </el-col>
                <el-col :span="12" align="right">
                    <el-form-item label="货期(days)" required>
                        <el-input-number v-model="currentProduct.leadtime" :min="7" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="备注">
                <el-input v-model="currentProduct.notes" type="textarea" :rows="2" />
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="productDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleProductSubmit">确认</el-button>
            </span>
        </template>
    </el-dialog>
    <el-drawer v-model="drawerVisible" size="min(1250px, 96vw)" destroy-on-close="true">
        <QuotationDrawer :doc="showQuote"
                         :cust="companyinfo" />
    </el-drawer>


</template>

<script>
    import axios from "axios";
    import Qs from "qs";
    import QuotationDrawer from './quotationdrawer'
    import { Trush } from '@element-plus/icons-vue'

    export default {
        name: 'quotation',
        props: ['companyinfo'],
        components: { QuotationDrawer },
        emits: ['update-records'],
        data() {
            return {
                drawerVisible: false,
                products: [],
                productOptions: [],
                productLoading: false,
                documents: [],
                QuoteDialog: false,
                productDialogVisible: false,
                isEditProduct: false,
                currentProductIndex: -1,
                IncotermOptions: ['EXW', 'FOB', 'C&F', 'CIF', 'CFR', 'DDP','DDU'],
                PaymentOptions: ['T/T', 'L/C', 'paypal'],
                PortOptions: ['Wuhan', 'Shenzhen', 'shanghai', 'customized'],
                CurrentQuote: {
                    profileid: null,
                    Deposit: 100,
                    Balance: 0,
                    Currency: 'USD',
                    buyerNo: '',
                    products: [],
                    payment: 'T/T 100% in advance',
                    Incoterm: 'EXW',
                    Port: "Wuhan",
                    CO: 'CHINA',
                    validate: 30,
                    destination: '',
                },
                currentProduct: {
                    productid: null,
                    productmodel: '',
                    qty: 1,
                    leadtime: 7,
                    price: 0,
                    img: '',
                    proddescription: '',
                    notes: '',
                    warranty: 36
                },
                productQuery: {
                    keyword: '',
                    categoryid: ''
                },
                recordList: [],
                showQuote: {},
                // 抬头公司（profileid 默认来源）
                myCompanies: [],
                allProfile: [],
                srcProfileid: null,
                srcLabel: '',
                myDefault: null,
                globalDefault: null,
                companies: [],
                isadmin: false,
            };
        },
        computed: {
            Deliverycul() {
                if (!this.CurrentQuote.products || !this.CurrentQuote.products.length) {
                    return 0;
                }
                return Math.max(...this.CurrentQuote.products.map(p => p.leadtime || 0))
            },
            quoteproducts() {
                let result = "";
                const products = this.CurrentQuote.products || [];
                result = products.length
                products.forEach(product => {
                    if (product.productid) { result = result + "||" + product.productid + "!" + product.productmodel + "!" + product.qty + "!" + product.price + "!" + product.leadtime + "!" + product.notes + "!" + product.warranty + "!" + product.proddescription }
                });
                return result
            },
            dialogTitle() {
                return `${this.companyinfo.companyname} ${this.CurrentQuote.QuoteId ? '编辑' : '新增'}报价`;
            },
            productDialogTitle() {
                return this.isEditProduct ? '编辑产品' : '添加产品';
            },
            quoteAmount() {
                if (!this.CurrentQuote.products || !this.CurrentQuote.products.length) {
                    return 0;
                }
                return this.CurrentQuote.products.reduce((total, product) => {
                    const price = product.price || 0;
                    const quantity = product.qty || 0;
                    return total + (price * quantity);
                }, 0);
            },
            currentDate() {
                const today = new Date();
                const dd = String(today.getDate()).padStart(2, '0');
                const mm = String(today.getMonth() + 1).padStart(2, '0');
                const yyyy = today.getFullYear();
                return mm + '/' + dd + '/' + yyyy;
            }
        },
        watch: {
            'companyinfo': {
                handler(newVal) {
                    if (newVal && newVal.companyid) {
                        this.fetchQuotationList();
                        this.refreshSourceProfile();
                    }
                },
                immediate: true
            }
        },
        created() {
            this.fetchprofile();
        },
        mounted() {
            this.fetchQuotationList();
            this.fetchProductOptions();
        },
        methods: {
            fetchprofile() {
                const adminid = localStorage.getItem('userid')
                this.isadmin = adminid === '1' // 假设管理员的ID为1
                const reqProfile = axios({
                    url: '/apiserve/crmapi/system.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: { action: 'profile', Selection: 'all' }
                })
                const reqMyCompanies = axios({
                    url: '/apiserve/crmapi/system.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: { action: 'my_companies' }
                })

                Promise.all([reqProfile, reqMyCompanies]).then(([resProfile, resMy]) => {
                    this.allProfile = (resProfile.data && resProfile.data.profile) || []
                    const profile = this.allProfile.find(item => item.default === true) || this.allProfile[0]
                    this.globalDefault = profile ? profile.id : null

                    this.myCompanies = (resMy.data && resMy.data.companies) || []
                    const myDef = this.myCompanies.find(c => Number(c.is_default) === 1)
                    this.myDefault = myDef ? myDef.id : (this.myCompanies.length === 1 ? this.myCompanies[0].id : null)

                    this.refreshSourceProfile()
                }).catch(e => {
                    console.error('fetchprofile error', e)
                    this.recomputeQuoteDefault()
                })
            },
            // 客户公司优先：取客户原始所属公司（raw_profileid，无则 null），随后重算默认
            refreshSourceProfile() {
                const cid = this.companyinfo && this.companyinfo.companyid
                if (!cid) {
                    this.srcProfileid = null
                    this.srcLabel = ''
                    this.recomputeQuoteDefault()
                    return
                }
                axios({
                    url: '/apiserve/crmapi/customersapi.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: { action: 'getcustomer', companyid: cid }
                }).then(response => {
                    const d = response.data
                    if (d && d.raw_profileid !== null && d.raw_profileid !== undefined && d.raw_profileid !== '') {
                        this.srcProfileid = Number(d.raw_profileid)
                        this.srcLabel = d.sellercompany || ''
                    } else {
                        this.srcProfileid = null
                        this.srcLabel = ''
                    }
                    this.recomputeQuoteDefault()
                }).catch(() => {
                    this.srcProfileid = null
                    this.srcLabel = ''
                    this.recomputeQuoteDefault()
                })
            },
            // 计算新 PI 默认抬头：客户公司 -> 本人默认 -> 全局默认；并组装下拉选项
            recomputeQuoteDefault() {
                const inOpt = id => this.companies.some(o => String(o.id) === String(id))
                if (this.isadmin) {
                    this.companies = this.allProfile.map(p => ({
                        id: p.id,
                        profilename: p.profilename || p.companyname,
                        companyname: p.companyname,
                    }))
                } else {
                    const opts = this.myCompanies.map(c => ({ id: c.id, companyname: c.companyname }))
                    // 客户所属公司不在本人集合时，追加可选项（用户确认：可选）
                    if (this.srcProfileid && !opts.some(o => String(o.id) === String(this.srcProfileid))) {
                        opts.push({
                            id: this.srcProfileid,
                            companyname: (this.srcLabel || '客户所属') + '（客户所属）',
                        })
                    }
                    this.companies = opts
                }
                let def = null
                if (this.srcProfileid && inOpt(this.srcProfileid)) {
                    def = this.srcProfileid
                } else if (this.myDefault && inOpt(this.myDefault)) {
                    def = this.myDefault
                } else if (this.globalDefault && inOpt(this.globalDefault)) {
                    def = this.globalDefault
                } else if (this.companies.length) {
                    def = this.companies[0].id
                }
                this.CurrentQuote.profileid = def
            },
            deletequotation(id) {
                console.log('开始删除' + id)
                axios({
                    url: '/apiserve/crmapi/documents.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: {
                        action: 'deletequotation',
                        docid: id
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.fetchQuotationList()
                        }
                    })
            },
            checkquotation(quoteInfo) {
                this.showQuote = quoteInfo
                this.drawerVisible = true
            },
            docnocal(id, code) {
                id = "000000" + id
                id = id.substring(id.length - 6)
                return code + '-' + id
            },
            fetchProductOptions() {
                this.productLoading = true;
                axios({
                    url: '/apiserve/crmapi/products.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: {
                        action: 'products',
                    }
                }).then(response => {
                    this.productOptions = response.data.products;
                }).finally(() => {
                    this.productLoading = false;
                });
            },
            handleProductSelect(productCode) {
                console.log(productCode)
                const selected = this.productOptions.find(item => item.productid === productCode);
                console.log(selected)
                if (selected) {
                    const productData = selected;
                    this.currentProduct = {
                        productid: productData.productid,
                        productmodel: productData.productcode,
                        qty: 1,
                        leadtime: 7,
                        price: productData.unitprice,
                        img: productData.photo || '',
                        proddescription: productData.description,
                        warranty: productData.productwarranty || 36,
                        notes: ''
                    };
                }
            },
            fetchQuotationList() {
                if (this.companyinfo.companyid) {
                    axios({
                        url: '/apiserve/crmapi/documents.asp',
                        method: 'post',
                        transformRequest: [function (data) {
                            return Qs.stringify(data)
                        }],
                        data: {
                            action: 'quotationlist',
                            companyid: this.companyinfo.companyid
                        }
                    }).then(response => {
                        this.documents = response.data.documents;
                        this.recordList = this.documents || [];
                        this.$emit('update-records', this.recordList);
                    });
                }

            },
            showQuoteDialog() {
                this.recomputeQuoteDefault();
                this.QuoteDialog = true;
                if (!this.CurrentQuote.QuoteId) {
                    this.CurrentQuote.QuoteId = this.createQuoteNo();
                }
            },
            showAddProductDialog() {
                this.isEditProduct = false;
                this.currentProductIndex = -1;
                this.resetCurrentProduct();
                this.productDialogVisible = true;
                this.fetchProductOptions();
            },
            editProduct(product, index) {
                this.isEditProduct = true;
                this.currentProductIndex = index;
                this.currentProduct = JSON.parse(JSON.stringify(product));
                this.productDialogVisible = true;
            },
            removeProduct(index) {
                this.$confirm('确定要删除这个产品吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.CurrentQuote.products.splice(index, 1);
                    this.updateTotals();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleProductSubmit() {
                if (!this.currentProduct.productmodel) {
                    this.$message.error('请填写产品型号');
                    return;
                }
                if (this.isEditProduct && this.currentProductIndex >= 0) {
                    // 更新现有产品
                    this.CurrentQuote.products[this.currentProductIndex] = this.currentProduct
                    //this.$set(this.CurrentQuote.products, this.currentProductIndex, JSON.parse(JSON.stringify(this.currentProduct)));
                } else {
                    // 添加新产品
                    this.currentProduct.productid = this.currentProduct.productid || Date.now(); // 生成唯一ID
                    this.CurrentQuote.products.push(JSON.parse(JSON.stringify(this.currentProduct)));
                }
                this.updateTotals();
                this.productDialogVisible = false;
            },
            updateTotals() {
                // 触发重新计算总计
                this.$forceUpdate();
            },
            submitQuote() {
                if (!this.CurrentQuote.products.length) {
                    this.$message.error('请至少添加一个产品');
                    return;
                }
                if (!this.CurrentQuote.buyerNo) {
                    this.$message.error('请选择联系人');
                    return;
                }
                this.CurrentQuote.Delivery = this.Deliverycul
                const quoteData = {
                    action: 'savequotation',
                    companyid: this.companyinfo.companyid,
                    quoteinfo: JSON.stringify(this.CurrentQuote),
                    products: this.quoteproducts,
                    totalAmount: this.quoteAmount
                };
                axios({
                    url: '/apiserve/crmapi/documents.asp',
                    method: 'post',
                    transformRequest: [function (data) {
                        return Qs.stringify(data)
                    }],
                    data: quoteData
                }).then(response => {
                    console.log(response.data)
                    this.$message.success('报价保存成功');
                    this.QuoteDialog = false;
                    this.fetchQuotationList();

                })
            },
            resetCurrentProduct() {
                this.currentProduct = {
                    productid: null,
                    productmodel: '',
                    qty: 1,
                    leadtime: '',
                    price: 0,
                    img: '',
                    proddescription: '',
                    notes: ''
                };
            },
            createQuoteNo() {
                return "WHHM" + new Date().getFullYear() +
                    ("0" + (new Date().getMonth() + 1)).slice(-2) +
                    ("0" + new Date().getDate()).slice(-2);
            },
            handleQuoteSelect(e) {
                console.log('Selected product:', e);
            },
            sortChange(column) {
                console.log('Sort changed:', column);
            }
        }
    };
</script>

